import React from 'react';
import { i18n } from 'next-i18next';
import { ThemeProvider, fontFamilies } from '@sy/component-library';
import WrapWithProviders from '@sy/app-client/src/ssrAdapter/ssrWrapper';
import Footer from '@sy/app-client/src/ssrAdapter/components/Footer';
import LandingHeader from '@sy/app-client/src/ssrAdapter/components/LandingHeader';
import type { CacheNavigation } from '@sy/ssr-types';

import { Layout, Top } from './MarketingTemplate.styles';
import WithGoogleOneTap from './WithGoogleOneTap';

const MarketingTemplate = ({
	activePage,
	children,
	navigation,
	overflowVisible,
	user,
	useDarkNewBrandingSurface,
}: Props) => {
	const useDark = useDarkNewBrandingSurface ?? false;

	return (
		<WrapWithProviders i18n={i18n} user={user} withTheme={false}>
			<ThemeProvider
				themeName={useDark ? 'dark' : 'marketing'}
				isGlobal
				isCustom={useDark}
				fontFamily={fontFamilies.plusJakartaSans}
			>
				<>
					<WithGoogleOneTap />
					<Layout
						overflowVisible={overflowVisible}
						$useDarkNewBrandingSurface={useDark}
					>
						<Top>
							<LandingHeader
								activePage={activePage}
								header={navigation?.header}
								useDarkNewBrandingSurface={useDark}
							/>
							{children}
						</Top>
					</Layout>
					<Footer useDarkNewBrandingSurface={useDark} />
				</>
			</ThemeProvider>
		</WrapWithProviders>
	);
};

interface Props {
	activePage?: string;
	children: React.ReactNode;
	overflowVisible?: boolean;
	navigation?: CacheNavigation | null;
	user: { email: string | null; id: string | null };
	useDarkNewBrandingSurface?: boolean;
}

export default MarketingTemplate;
